import { useCallback } from "react";

import { useAuth } from "@/providers/auth-provider";

/**
 * Hook that provides a logout handler with error handling
 *
 * @returns A function that handles logout with error handling
 */
export const useLogout = () => {
	const { logout } = useAuth();

	const handleLogout = useCallback(async () => {
		try {
			await logout();
		} catch (error) {
			console.error("Failed to sign out:", error);
		}
	}, [logout]);

	return handleLogout;
};
